import { globalAllHandler } from '@/components/element/attrs/globalOption'

import cpt_dataV_border_option from '@/components/dataV/attrs/cpt-dataV-border-option'
import cpt_button_option from '@/components/element/attrs/cpt-button-option'
import cpt_button_update_option from '@/components/element/attrs/cpt-button-update-option'
import cpt_button_delete_option from '@/components/element/attrs/cpt-button-delete-option'
import cpt_video_player_option from '@/components/element/attrs/cpt-video-player-option'
// import cpt_live_option from '@/components/element/attrs/cpt-live-option'

import cpt_audio_option from '@/components/element/attrs/cpt-audio-option'
import cpt_ninegrid_option from '@/components/element/attrs/cpt-ninegrid-option'
import cpt_carousel_option from '@/components/element/attrs/cpt-carousel-option'
import cpt_input_option from '@/components/element/attrs/cpt-input-option'
import cpt_input_option_mobile from '@/components/mobile/attrs/cpt-input-option'
import cpt_link_card_option from '@/components/element/attrs/cpt-link-card-option'
import cpt_scroll_text_option from '@/components/element/attrs/cpt-scroll-text-option'
import cpt_image_option from '@/components/element/attrs/cpt-image-option'
import cpt_dataV_decoration_option from '@/components/dataV/attrs/cpt-dataV-decoration-option'
import cpt_dataV_activeRing_option from '@/components/dataV/attrs/cpt-dataV-activeRing-option'
import cpt_dataV_waterLevel_option from '@/components/dataV/attrs/cpt-dataV-waterLevel-option'
import cpt_dataV_percentPond_option from '@/components/dataV/attrs/cpt-dataV-percentPond-option'
import cpt_datetime_option from '@/components/element/attrs/cpt-datetime-option'
import cpt_tab_option from '@/components/element/attrs/cpt-tab-option'
import cpt_fullscreen_option from '@/components/element/attrs/cpt-fullscreen-option'
import cpt_checkbox_option from '@/components/element/attrs/cpt-checkbox-option'
import cpt_select_option from '@/components/element/attrs/cpt-select-option'
import cpt_select_option_mobile from '@/components/mobile/attrs/cpt-select-option'
import cpt_jumper_option from '@/components/element/attrs/cpt-jumper-option'
import cpt_num_option from '@/components/element/attrs/cpt-num-option'
import cpt_rect_num_option from '@/components/element/attrs/cpt-rect-num-option'
import cpt_chart_radar_option from '@/components/echarts/attrs/cpt-chart-radar-option'
import cpt_chart_progress_ring_option from '@/components/echarts/attrs/cpt-chart-progress-ring-option'
import cpt_chart_line_option from '@/components/echarts/attrs/cpt-chart-line-option'
import cpt_chart_column_option from '@/components/echarts/attrs/cpt-chart-column-option'
import cpt_chart_pie_option from '@/components/echarts/attrs/cpt-chart-pie-option'
import cpt_chart_scrollList_option from '@/components/echarts/attrs/cpt-chart-scroll-list-option'
import cpt_table_option from '@/components/element/attrs/cpt-table-option'
import cpt_chart_scatter_option from '@/components/echarts/attrs/cpt-chart-scatter-option'
import cpt_chart_column_region_option from '@/components/echarts/attrs/cpt-chart-column-region-option'
import cpt_chart_polycyclic_option from '@/components/echarts/attrs/cpt-chart-polycyclic-option'
import cpt_ring_pie_option from '@/components/echarts/attrs/cpt-ring-pie-option'
import cpt_scroll_table_option from '@/components/element/attrs/cpt-scroll-table-option'
import cpt_text_option from '@/components/element/attrs/cpt-text-option'
import cpt_iframe_option from '@/components/element/attrs/cpt-iframe-option'
import cpt_total_option from '@/components/element/attrs/cpt-total-option'
import cpt_g6_dom_option from '@/components/g6/attr/cpt-g6-dom-option'
import cpt_chart_map_gc_option from '@/components/echarts/attrs/cpt-chart-map-gc-option'
import cpt_chart_map_migrate_option from '@/components/echarts/attrs/cpt-chart-map-migrate-option'
import cpt_chart_map_3d_option from '@/components/echarts/attrs/cpt-chart-map-3d-option'
import cpt_chart_column_stack_option from '@/components/echarts/attrs/cpt-chart-column-stack-option'
import cpt_chart_column_3d_option from '@/components/echarts/attrs/cpt-chart-column-3d-option'
import cpt_chart_column_crisscross_option from '@/components/echarts/attrs/cpt-chart-column-crisscross-option'
import cpt_chart_column_line_option from '@/components/echarts/attrs/cpt-chart-column-line-option'
import cpt_chart_funnel_option from '@/components/echarts/attrs/cpt-chart-funnel-option'
import cpt_chart_scatter_po_option from '@/components/echarts/attrs/cpt_chart_scatter_po_option'
import cpt_icon_quota_option from '@/components/element/attrs/cpt-icon-quota-option'
import cpt_chart_gauge_option from '@/components/echarts/attrs/cpt-chart-gauge-option'
import cpt_chart_gauge_gradual_option from '@/components/echarts/attrs/cpt-chart-gauge-gradual-option'
import cpt_chart_candlestick_option from '@/components/echarts/attrs/cpt-chart-candlestick-option'
import cpt_chart_candlestick_line_option from '@/components/echarts/attrs/cpt-chart-candlestick-line-option'
import cpt_chart_column_stereo_option from '@/components/echarts/attrs/cpt-chart-column-stereo-option'
import cpt_threejs_dom_option from '@/components/three/attrs/cpt-threejs-dom-option'
import cpt_three_server_room_option from '@/components/three/attrs/cpt-three-server-room-option'
import cpt_img_quota_option from '@/components/other/attrs/cpt-img-quota-option'
import cpt_icon_ring_option from '@/components/other/attrs/cpt-icon-ring-option'
import cpt_time_run_option from '@/components/element/attrs/cpt-time-run-option'
import cpt_indicator_option from '@/components/element/attrs/cpt-indicator-option'
import cpt_chart_line_multiple_option from '@/components/echarts/attrs/cpt-chart-line-multiple-option'
import cpt_chart_line_dual_option from '@/components/echarts/attrs/cpt-chart-line-dual-option'
import cpt_chart_map_3d_line_option from '@/components/echarts/attrs/cpt-chart-map-3d-line-option'
import cpt_chart_pie_3d_option from '@/components/echarts/attrs/cpt-chart-pie-3d-option'
import cpt_quota_progress_option from '@/components/element/attrs/cpt-quota-progress-option'
import cpt_img_state_option from '@/components/element/attrs/cpt-img-state-option'
import cpt_navigator_option from '@/components/element/attrs/cpt-navigator-option'
import cpt_scroll_list_option from '@/components/element/attrs/cpt-scroll-list-option'
import cpt_water_prop_option from '@/components/echarts/attrs/cpt-water-prop-option'
import cpt_chart_rect_stack_option from '@/components/echarts/attrs/cpt-chart-rect-stack-option'
import cpt_chart_wordcloud_option from '@/components/echarts/attrs/cpt-chart-wordcloud-option'
import cpt_chart_line_3d_option from '@/components/echarts/attrs/cpt-chart-line-3d-option'
import cpt_tree_option from '@/components/element/attrs/cpt-tree-option'
import cpt_page_option from '@/components/element/attrs/cpt-page-option'
import cpt_switch_option from '@/components/element/attrs/cpt-switch-option'
import cpt_phone_option from '@/components/element/attrs/cpt-phone-option'
import cpt_drawarea_option from '@/components/element/attrs/cpt-drawarea-option'
import cpt_realtime_position_option from '@/components/element/attrs/cpt-realtime-position-option'
import cpt_display_trail_option from '@/components/element/attrs/cpt-display-trail-option'
import cpt_choose_place_option from '@/components/element/attrs/cpt-choose-place-option'
// import cpt_tree_select_option from '@/components/element/attrs/cpt-tree-select-option'
import cpt_password_option from '@/components/element/attrs/cpt-password-option'
import cpt_badge_option from '@/components/element/attrs/cpt-badge-option'
import cpt_map_navigator_option from '@/components/element/attrs/cpt-map-navigator-option'
import cpt_amount_option from '@/components/element/attrs/cpt-amount-option'
import cpt_number_option from '@/components/element/attrs/cpt-number-option'
import cpt_phone_number_option from '@/components/element/attrs/cpt-phone-number-option'
import cpt_scan_option from '@/components/element/attrs/cpt-scan-option'
import cpt_date_picker from '@/components/element/attrs/cpt-date-picker'
import cpt_calendar_option from '@/components/element/attrs/cpt-calendar-option'
import cpt_date_picker_mobile from '@/components/mobile/attrs/cpt-date-picker'
import cpt_radio_option from '@/components/element/attrs/cpt-radio-option'
import cpt_time_picker from '@/components/element/attrs/cpt-time-picker-option'
import cpt_input_search_option from '@/components/element/attrs/cpt-input-search-option'
import cpt_suspension_option from '@/components/element/attrs/cpt-suspension-option'
import cpt_qrcode_option from '@/components/element/attrs/cpt-qrcode-option'
import cpt_textarea_option from '@/components/element/attrs/cpt-textarea-option'
import cpt_iconfont_option from '@/components/element/attrs/cpt-iconfont-option'
import cpt_richtxt_option from '@/components/element/attrs/cpt-richtxt-option'
import cpt_combination_page_option from '@/components/element/attrs/cpt-combination-page-option'
import { setGlobalAttr } from '@/components/element/attrs/globalOption'


const cpt_dataV_waterLevel_r_option = JSON.parse(JSON.stringify(cpt_dataV_waterLevel_option))
cpt_dataV_waterLevel_r_option.attribute.shape = 'round'

const cpt_chart_column_region_h_option = JSON.parse(JSON.stringify(cpt_chart_column_region_option))
cpt_chart_column_region_h_option.attribute.direction = 'y'
cpt_chart_column_region_h_option.attribute.series.label.position = 'right'

const cpt_chart_column_h_option = JSON.parse(JSON.stringify(cpt_chart_column_option))
cpt_chart_column_h_option.attribute.direction = 'y'
cpt_chart_column_h_option.attribute.series.barWidth = 8
cpt_chart_column_h_option.attribute.series.label.position = 'right'

const cpt_chart_pie_ring_option = JSON.parse(JSON.stringify(cpt_chart_pie_option))
cpt_chart_pie_ring_option.attribute.series.radius[0] = 40
const cpt_chart_pie_ring_m_option = JSON.parse(JSON.stringify(cpt_chart_pie_option))
cpt_chart_pie_ring_m_option.attribute.series.radius[0] = 40
cpt_chart_pie_ring_m_option.attribute.series.roseType = 'radius'
const cpt_chart_pie_m_option = JSON.parse(JSON.stringify(cpt_chart_pie_option))
cpt_chart_pie_m_option.attribute.series.roseType = 'radius'
const cpt_chart_line_area_option = JSON.parse(JSON.stringify(cpt_chart_line_option))
cpt_chart_line_area_option.attribute.areaShow = true
const cpt_chart_line_point_option = JSON.parse(JSON.stringify(cpt_chart_line_option))
cpt_chart_line_point_option.attribute.lineShow = false
cpt_chart_line_point_option.attribute.symbolSize = 16

const cpt_chart_radar_circle_option = JSON.parse(JSON.stringify(cpt_chart_radar_option))
cpt_chart_radar_circle_option.attribute.radar.shape = 'circle'

const cpt_chart_column_stack_h_option = JSON.parse(JSON.stringify(cpt_chart_column_stack_option))

cpt_chart_column_stack_h_option.attribute.direction = 'y'
cpt_chart_column_stack_h_option.attribute.xAxis.splitLine.show = true
cpt_chart_column_stack_h_option.attribute.yAxis.splitLine.show = false

const cpt_chart_column_stack_pa_option = JSON.parse(JSON.stringify(cpt_chart_column_stack_option))
cpt_chart_column_stack_pa_option.attribute.enablePa = '1'

const cpt_chart_column_crisscross_h_option = JSON.parse(JSON.stringify(cpt_chart_column_crisscross_option))
cpt_chart_column_crisscross_h_option.attribute.direction = 'y'
cpt_chart_column_crisscross_h_option.attribute.title.left = '10'


const allOption = [
    {
        name: '基础组件', icon: 'basic', opened: true,
        children: [
            { name: '边框', icon: 'border', cptKey: 'cpt-dataV-border', option: cpt_dataV_border_option },
            { name: '按钮', icon: 'btn', cptKey: 'cpt-button', width: 150, height: 40, option: cpt_button_option },
            { name: '文本', icon: 'text', cptKey: 'cpt-text', width: 150, height: 40, option: cpt_text_option },
            { name: '滚动文字', icon: 'scrollText', cptKey: 'cpt-scroll-text', width: 250, height: 50, option: cpt_scroll_text_option },
            { name: '图片', icon: 'img', cptKey: 'cpt-image', option: cpt_image_option },
            { name: '轮播图', icon: 'swiper', cptKey: 'cpt-carousel', option: cpt_carousel_option },
            { name: '装饰', icon: 'decoration', cptKey: 'cpt-dataV-decoration', option: cpt_dataV_decoration_option },
            // {name: 'iframe', icon: 'iframe', cptKey: 'cpt-iframe',
            //     option: {
            //         attribute: { url: 'https://www.rainy.pub/' },
            //         interaction: { intType: 'none' }
            //     }
            // },
            { name: 'iframe', icon: 'iframe', cptKey: 'cpt-iframe', width: 600, height: 360, option: cpt_iframe_option },
            { name: '静态表格', icon: 'table', cptKey: 'cpt-table', option: cpt_table_option, width: 600, height: 360 },
            { name: '滚动表格', icon: 'scroll_table', cptKey: 'cpt-scroll-table', option: cpt_scroll_table_option },
            { name: '滚动列表', icon: '', cptKey: 'cpt-scroll-list', option: cpt_scroll_list_option },
            { name: '当前时间', icon: 'time', cptKey: 'cpt-datetime', width: 250, height: 50, option: cpt_datetime_option },
            { name: '视频', icon: 'video', cptKey: 'cpt-video-player', option: cpt_video_player_option },
            // { name: '直播', icon: 'video', cptKey: 'cpt-live', option: cpt_live_option },
            { name: '音频', icon: 'audio', cptKey: 'cpt-audio', width: 150, height: 40, option: cpt_audio_option },
            {
                name: '天气', icon: 'weather', cptKey: 'cpt-weather', width: 100, height: 100,
                option: {
                    attribute: { cityName: '', refreshFlag: false, apiKey: 'SzD0xw_NYlg7dNdKz' },
                    interaction: { intType: 'none' }
                }
            },

            {
                name: '全屏', icon: 'fullscreen', cptKey: 'cpt-fullscreen', width: 40, height: 40,
                option: cpt_fullscreen_option,
            }

        ]
    }, {
        name: '控件', icon: 'other', opened: false,
        children: [
            // { name: '选项卡', icon: 'tab', cptKey: 'cpt-tab', width: 500, height: 40, option: cpt_tab_option },
            { name: '组合选项卡', icon: 'tab', cptKey: 'cpt-tab', width: 500, height: 40, option: cpt_tab_option, type: 'combination' },
            { name: '输入框', icon: 'input', cptKey: 'cpt-input', width: 300, height: 50, option: cpt_input_option },
            { name: '多行文本', icon: 'textarea', cptKey: 'cpt-textarea', width: 300, height: 100, option: cpt_textarea_option },
            { name: '下拉框', icon: 'select', cptKey: 'cpt-select', width: 300, height: 50, option: cpt_select_option, multiple: false },
            { name: '日期选择', icon: 'date_picker', cptKey: 'cpt-date-picker', width: 300, height: 50, option: cpt_date_picker },
            { name: '日历', icon: 'time_picker', cptKey: 'cpt-calendar', width: 300, height: 300, option: cpt_calendar_option },
            { name: '时间选择', icon: 'time_picker', cptKey: 'cpt-time-picker', width: 300, height: 50, option: cpt_time_picker },
            { name: '单选框', icon: 'radio', cptKey: 'cpt-radio', width: 400, height: 40, option: cpt_radio_option },
            { name: '复选框', icon: 'checkbox', cptKey: 'cpt-checkbox', width: 400, height: 40, option: cpt_checkbox_option },
            { name: '开关', icon: 'switch', cptKey: 'cpt-switch', width: 150, height: 35, option: cpt_switch_option },
            { name: '密码', icon: 'password', cptKey: 'cpt-password', width: 300, height: 50, option: cpt_password_option },
            { name: '金额', icon: 'amount', cptKey: 'cpt-amount', width: 300, height: 50, option: cpt_amount_option },
            { name: '密码组', icon: 'password', cptKey: 'cpt-password-ground', width: 300, height: 100, option: cpt_password_option, type: 'combination-password' },
            { name: '数字', icon: 'number', cptKey: 'cpt-number', width: 300, height: 50, option: cpt_number_option },
            { name: '手机号', icon: 'phonenumber', cptKey: 'cpt-phone-number', width: 300, height: 50, option: cpt_phone_number_option },
            { name: '跳转', icon: 'jumper', cptKey: 'cpt-jumper', width: 300, height: 50, option: cpt_jumper_option },
            { name: '导航器', icon: 'default', cptKey: 'cpt-navigator', width: 400, height: 20, option: cpt_navigator_option },
            { name: '分页', icon: 'paging', cptKey: 'cpt-page', width: 650, height: 50, cptOptionKey: 'cpt-page-option', option: cpt_page_option },
            { name: '组合分页器', icon: 'paging', cptKey: 'cpt-combination-page', width: 90, height: 35, option: cpt_combination_page_option },
            { name: '按钮组', icon: 'btn', cptKey: 'cpt-button-group', width: 320, height: 40, option: cpt_button_option },
            { name: '树', icon: 'tree', cptKey: 'cpt-tree', width: 250, height: 450, option: cpt_tree_option },
            { name: '九宫格', icon: 'ninegrid', cptKey: 'cpt-ninegrid', width: 600, height: 400, option: cpt_ninegrid_option, type: 'ngcombination' },
            { name: '合计', icon: 'text', cptKey: 'cpt-total', width: 150, height: 40, option: cpt_total_option },
            { name: '电话', icon: 'phone', cptKey: 'cpt-phone', width: 230, height: 35, cptOptionKey: 'cpt-phone-option', option: cpt_phone_option },
            { name: '区域绘制', icon: 'drawarea', cptKey: 'cpt-drawarea', width: 150, height: 40, cptOptionKey: 'cpt-drawarea-option', option: cpt_drawarea_option },
            { name: '显示位置', icon: 'realtime_position', cptKey: 'cpt-realtime-position', width: 360, height: 780, cptOptionKey: 'cpt-realtime-position-option', option: cpt_realtime_position_option },
            { name: '选择位置', icon: 'choose_place', cptKey: 'cpt-choose-place', width: 230, height: 40, cptOptionKey: 'cpt-choose-place-option', option: cpt_choose_place_option },
            // {name: '选择位置', icon: 'choose_place',  cptKey: 'cpt-choose-ground', width:300,  height:80, option: cpt_choose_place_option},   
            { name: '显示轨迹', icon: 'display_trail', cptKey: 'cpt-display-trail', width: 360, height: 780, cptOptionKey: 'cpt-display-trail-option', option: cpt_display_trail_option },
            // { name: '树选择', icon: 'select', cptKey: 'cpt-tree-select', width: 300, height: 50, option: cpt_tree_select_option },
            { name: '地图导航', icon: 'mapnavigator', cptKey: 'cpt-map-navigator', width: 80, height: 40, option: cpt_map_navigator_option },
            { name: '扫描', icon: 'scan', cptKey: 'cpt-scan', width: 70, height: 70, option: cpt_scan_option },
            { name: '角标', icon: 'badge', cptKey: 'cpt-badge', width: 150, height: 50, option: cpt_badge_option },
            { name: '保存&更新', icon: 'btn', cptKey: 'cpt-button', width: 100, height: 30, option: cpt_button_update_option, type: 'button-update' },
            { name: '删除', icon: 'btn', cptKey: 'cpt-button', width: 100, height: 30, option: cpt_button_delete_option, type: 'button-delete' },
            { name: '文本搜索', icon: 'inputselect', cptKey: 'cpt-input-search', width: 100, height: 30, option: cpt_input_search_option },
            { name: '悬浮框', icon: 'xfk', cptKey: 'cpt-suspension', width: 375, height: 55, option: cpt_suspension_option, type: 'cpt-suspension' },
            { name: '二维码', icon: 'qrcode', cptKey: 'cpt-qrcode', width: 100, height: 100, option: cpt_qrcode_option },
            { name: '图标', icon: 'detaul-icon', cptKey: 'cpt-iconfont', width: 40, height: 40, option: cpt_iconfont_option },
            { name: '显示富文本', icon: 'richtxt', cptKey: 'cpt-richtxt', width: 300, height: 300, option: cpt_richtxt_option },
        ]
    }, {
        name: '控件(移动端)', icon: 'other', opened: false,
        children: [
            { name: '输入框', icon: 'input', cptKey: 'cpt-input-mobile', width: 300, height: 50, option: cpt_input_option_mobile },
            { name: '选择器', icon: 'select', cptKey: 'cpt-select-mobile', width: 300, height: 50, option: cpt_select_option_mobile, multiple: false },
            { name: '时间选择', icon: 'date_picker', cptKey: 'cpt-date-picker-mobile', width: 300, height: 50, option: cpt_date_picker_mobile },
        ]
    }, {
        name: '指标卡', icon: 'quota', opened: false,
        children: [
            { name: '数值文本', icon: 'num_text', cptKey: 'cpt-num', width: 200, height: 80, option: cpt_num_option },
            { name: '统计指标', icon: 'icon_quota', cptKey: 'cpt-icon-quota', width: 140, height: 235, option: cpt_icon_quota_option },
            { name: '数字翻牌器', icon: 'num_loop', cptKey: 'cpt-rect-num', width: 350, height: 150, option: cpt_rect_num_option },
            { name: '计时器', icon: 'time_run', cptKey: 'cpt-time-run', width: 500, height: 80, option: cpt_time_run_option },
            { name: '增长指标', icon: 'indicator', cptKey: 'cpt-indicator', width: 500, height: 80, option: cpt_indicator_option },
            { name: '进度指标', icon: 'default', cptKey: 'cpt-quota-progress', width: 250, height: 120, option: cpt_quota_progress_option },
            { name: '链接卡片', icon: 'default', cptKey: 'cpt-link-card', width: 400, height: 160, option: cpt_link_card_option },
        ]
    }, {
        name: '柱状图', icon: 'zhuzhuangtu', opened: false,
        children: [
            { name: '基础柱状图', icon: 'zhuzhuang', cptKey: 'cpt-chart-column', option: cpt_chart_column_option, width: 500 },
            { name: '横向柱状图', icon: 'zhuzhuang2', cptKey: 'cpt-chart-column', option: cpt_chart_column_h_option },
            { name: '堆积柱状图', icon: 'zhuzhuang3', cptKey: 'cpt-chart-column-stack', cptOptionKey: 'cpt-chart-column-option', option: cpt_chart_column_stack_option, width: 500 },
            { name: '百分比堆积柱图', icon: 'zhuzhuang4', cptKey: 'cpt-chart-column-stack', cptOptionKey: 'cpt-chart-column-option', option: cpt_chart_column_stack_pa_option, width: 500 },
            { name: '横向堆积柱状图', icon: 'zhuzhuang5', cptKey: 'cpt-chart-column-stack', cptOptionKey: 'cpt-chart-column-option', option: cpt_chart_column_stack_h_option, width: 500, height: 400 },
            { name: '区间柱状图', icon: 'zhuzhuang6', cptKey: 'cpt-chart-column-region', cptOptionKey: 'cpt-chart-column-option', option: cpt_chart_column_region_option },
            { name: '横向区间柱状图', icon: 'zhuzhuang9', cptKey: 'cpt-chart-column-region', cptOptionKey: 'cpt-chart-column-option', option: cpt_chart_column_region_h_option },
            { name: '旋风柱状图', icon: 'zhuzhuang8', cptKey: 'cpt-chart-column', option: cpt_chart_column_crisscross_option },
            { name: '横向旋风图', icon: 'zhuzhuang7', cptKey: 'cpt-chart-column', option: cpt_chart_column_crisscross_h_option },
            { name: '排行榜', icon: 'scroll_list', cptKey: 'cpt-chart-scroll-list', option: cpt_chart_scrollList_option },
            { name: '立体柱状图', icon: 'column_stereo', cptKey: 'cpt-chart-column-stereo', option: cpt_chart_column_stereo_option },
            { name: '3D柱状图', icon: 'column_3d', cptKey: 'cpt-chart-column-3d', width: 500, height: 350, option: cpt_chart_column_3d_option },
        ]
    }, {
        name: '饼/环图', icon: 'bingtu', opened: false,
        children: [
            { name: '基础饼图', icon: 'pie', cptKey: 'cpt-chart-pie', option: cpt_chart_pie_option },
            { name: '玫瑰图', icon: 'pie_m', cptKey: 'cpt-chart-pie', option: cpt_chart_pie_m_option },
            { name: '环形图', icon: 'pie_ring1', cptKey: 'cpt-chart-pie', option: cpt_chart_pie_ring_option },
            { name: '玫瑰环图', icon: 'pie_ring3', cptKey: 'cpt-chart-pie', option: cpt_chart_pie_ring_m_option },
            { name: '同心环形图', icon: 'pie_ring2', cptKey: 'cpt-ring-pie', option: cpt_ring_pie_option },
            { name: '动态环形图', icon: 'pie_ring4', cptKey: 'cpt-dataV-activeRing', option: cpt_dataV_activeRing_option },
            { name: '聚环图', icon: 'polycyclic', cptKey: 'cpt-chart-polycyclic', option: cpt_chart_polycyclic_option },
            { name: '3D饼图', icon: 'default', cptKey: 'cpt-chart-pie-3d', option: cpt_chart_pie_3d_option },
        ]
    }, {
        name: '水位图', icon: 'shuiweitu', opened: false,
        children: [
            { name: '方形水位图', icon: 'water_rect', cptKey: 'cpt-dataV-waterLevel', width: 120, height: 100, option: cpt_dataV_waterLevel_option },
            { name: '圆形水位图', icon: 'water_ring', cptKey: 'cpt-dataV-waterLevel', width: 120, height: 100, option: cpt_dataV_waterLevel_r_option },
            { name: '水球图', icon: 'water_ring', cptKey: 'cpt-water-prop', width: 200, height: 200, option: cpt_water_prop_option },
        ]
    }, {
        name: '折线/折柱图', icon: 'zhexiantu', opened: false,
        children: [
            { name: '基础折线图', icon: 'line', cptKey: 'cpt-chart-line', option: cpt_chart_line_option },
            { name: '面积图', icon: 'line_area', cptKey: 'cpt-chart-line', option: cpt_chart_line_area_option },
            { name: '3D折线图', icon: 'line', cptKey: 'cpt-chart-line-3d', option: cpt_chart_line_3d_option },
            { name: '折线柱状图', icon: 'line_bar', cptKey: 'cpt-chart-column', option: cpt_chart_column_line_option, width: 500 },
            { name: '双Y轴折线柱图', icon: 'line_bar', cptKey: 'cpt-chart-line-dual', option: cpt_chart_line_dual_option, width: 600, height: 350 },
            { name: '多Y轴折线柱图', icon: 'line_bar', cptKey: 'cpt-chart-line-multiple', option: cpt_chart_line_multiple_option, width: 700, height: 400 },
            { name: '堆叠矩阵图', cptKey: 'cpt-chart-rect-stack', option: cpt_chart_rect_stack_option, width: 700, height: 400 }
        ]
    }, {
        name: 'k线/趋势', icon: 'kline', opened: false,
        children: [
            { name: '基础K线图', icon: 'kline_basic', cptKey: 'cpt-chart-candlestick', option: cpt_chart_candlestick_option },
            { name: 'K线走势', icon: 'kline_basic', cptKey: 'cpt-chart-candlestick', option: cpt_chart_candlestick_line_option, width: 700, height: 400 },
        ]
    }, {
        name: '仪表盘/进度', icon: 'yibiaopan', opened: false,
        children: [
            { name: '仪表盘', icon: 'gauge', cptKey: 'cpt-chart-gauge', width: 300, height: 200, option: cpt_chart_gauge_option },
            { name: '渐变仪表盘', icon: 'gauge_gradual', cptKey: 'cpt-chart-gauge', width: 320, height: 320, option: cpt_chart_gauge_gradual_option },
            { name: '进度池', icon: 'progress_pool', cptKey: 'cpt-dataV-percentPond', width: 300, height: 200, option: cpt_dataV_percentPond_option },
            { name: '环形进度', icon: 'progress_circle', cptKey: 'cpt-chart-progress-ring', width: 300, height: 400, option: cpt_chart_progress_ring_option }
        ]
    }, {
        name: '散点图', icon: 'sandiantu', opened: false,
        children: [
            { name: '基础散点图', icon: 'line_port', cptKey: 'cpt-chart-line', option: cpt_chart_line_point_option },
            { name: '气泡图', icon: 'scatter', cptKey: 'cpt-chart-scatter', width: 800, height: 500, option: cpt_chart_scatter_option },
            { name: '聚合散点图', icon: 'scatter_po', cptKey: 'cpt-chart-scatter', width: 500, height: 400, option: cpt_chart_scatter_po_option }
        ]
    }, {
        name: '雷达图', icon: 'leida', opened: false,
        children: [
            { name: '雷达图', icon: 'radar', cptKey: 'cpt-chart-radar', option: cpt_chart_radar_option, width: 320, height: 400 },
            { name: '圆形雷达图', icon: 'radar_circle', cptKey: 'cpt-chart-radar', option: cpt_chart_radar_circle_option, width: 320, height: 400 },
        ]
    }, {
        name: '关系图', icon: 'guanxitu', opened: false,
        children: [
            { name: '关系图', icon: 'relation', cptKey: 'cpt-g6-dom', option: cpt_g6_dom_option },
        ]
    }, {
        name: '漏斗图', icon: 'loudoutu', opened: false,
        children: [
            { name: '基础漏斗图', icon: 'loudou', cptKey: 'cpt-chart-funnel', option: cpt_chart_funnel_option },
        ]
    }, {
        name: '地图', icon: 'map', opened: false,
        children: [
            { name: '渐变地图', icon: 'map_gc', cptKey: 'cpt-chart-map-gc', option: cpt_chart_map_gc_option, width: 900, height: 600 },
            { name: '飞线地图', icon: 'map_road', cptKey: 'cpt-chart-map-migrate', option: cpt_chart_map_migrate_option, width: 900, height: 600 },
            { name: '3D地图', icon: 'map_3d', cptKey: 'cpt-chart-map-3d', width: 900, height: 600, option: cpt_chart_map_3d_option },
            { name: '3D飞线地图', icon: 'map_3d', cptKey: 'cpt-chart-map-3d-line', width: 900, height: 600, option: cpt_chart_map_3d_line_option },
        ]
    }, {
        name: '3D', icon: 'three', opened: false,
        children: [
            { name: '模型', icon: 'model', cptKey: 'cpt-threejs-dom', width: 900, height: 600, option: cpt_threejs_dom_option },
            { name: '机房场景', icon: 'model', cptKey: 'cpt-three-server-room', width: 900, height: 600, option: cpt_three_server_room_option }
        ]
    }, {
        name: '其它', icon: 'other', opened: false,
        children: [
            { name: '词云图', cptKey: 'cpt-chart-wordcloud', width: 800, height: 800, option: cpt_chart_wordcloud_option },
            { name: '告警图', cptKey: 'cpt-img-quota', width: 140, height: 170, option: cpt_img_quota_option },
            { name: '线路状态', cptKey: 'cpt-icon-ring', width: 200, height: 200, option: cpt_icon_ring_option },
            { name: '状态图', cptKey: 'cpt-img-state', width: 150, height: 100, option: cpt_img_state_option },
        ]
    }
]

// 添加全局属性
setGlobalAttr(allOption)




export default globalAllHandler(allOption)
